import { MenuItem, Select, Stack } from '@mui/material';
import React, { useState } from 'react';
import { theme } from '../../../theme';
import { CheckRounded,  CloseRounded, HowToRegRounded } from '@mui/icons-material';
import DropdownItem from './DropdownItem';

function ActionDropdown({ review, recommendation, handleUpdate, variant, clinical_review, implementer_review, isReadOnly }) {
    const [action, setAction] = useState(review.status);

    function handleChange(e) {
        setAction(e.target.value);
        handleUpdate(review, recommendation, e.target.value);
    }

    function getReviewType() {
        return review.type;
    }

    function getDisplayValue() {
        if (getReviewType() === 'clinical') {
            return clinicalActionDisplays[action];
        } else if (getReviewType() === 'implementer') {
            return implementerActionDisplays[action];
        }
    }

    function isDisabled() {
        if (variant === 'clinical') {
            if (clinical_review.submitted_at !== null) { return true; }
        } else if (variant === 'implementer') {
            if (implementer_review === null) { return true; }
            if (implementer_review.submitted_at !== null) { return true; }
        }

        if (isReadOnly) { return true; }

        return false;
    }

    const clinicalActionDisplays = {
        'open': <DropdownItem review={review} text={variant === 'implementer' ? 'Pending Review' : 'Action Required'} color={theme.palette.blue.main} disabled={isDisabled()} />,
        'accepted': <DropdownItem review={review} text='Approved' color={theme.palette.green.main} disabled={isDisabled()} icon={<CheckRounded />} />,
        'rejected': <DropdownItem review={review} text='Denied' color={theme.palette.red.main} disabled={isDisabled()} icon={<CloseRounded />} />,
        'staff_implemented': <DropdownItem review={review} text='Approved & Implemented' color={theme.palette.green.main} disabled={isDisabled()} icon={<HowToRegRounded />} />,
    }

    const implementerActionDisplays = {
        'open': <DropdownItem review={review} text='Action Required' color={theme.palette.blue.main} disabled={isDisabled()} />,
        'rejected': <DropdownItem review={review} text='Not Implemented' color={theme.palette.red.main} disabled={isDisabled()} icon={<CloseRounded />} />,
        'staff_implemented': <DropdownItem review={review} text='Implemented' color={theme.palette.green.main} disabled={isDisabled()} icon={<CheckRounded />} />,
    }

    
    return (
        <Stack alignItems='center'>
            <Select
                value={action}
                onChange={handleChange}
                sx={{
                    borderRadius: '0px',
                    '.MuiOutlinedInput-notchedOutline': {
                        border: 'none',
                        borderRadius: '0px'
                    },
                }}
                renderValue={getDisplayValue}
                inputProps={ isDisabled() ? { IconComponent: () => null, sx: { pr: '8 !important' }} : {} }
                disabled={isDisabled()}
            >
                <MenuItem value='open'>Action Required</MenuItem>
                { getReviewType() === 'clinical' && <MenuItem value='accepted'>Approved</MenuItem> }
                <MenuItem value='rejected'>{getReviewType() === 'implementer' ? 'Not Implemented' : 'Denied'}</MenuItem>
                <MenuItem value='staff_implemented'>{getReviewType() === 'implementer' ? 'Implemented' : 'Approved & Implemented'}</MenuItem>
            </Select>
            
        </Stack>
    );
}

export default ActionDropdown;

